import { get } from '@Lib/request'
import { path } from './url'

const { newCarApiV5, newCarApiV4, newCarApiV3 } = path

/** 规格配备 */
export async function fetchSpecification(params: any) {
    return await get(`${newCarApiV5}/kinds/equip-spec`, params);
}

/** 规格配备 - 最近浏览 */
export async function fetchComparedRecommend(params: any) {
    return await get(`${newCarApiV4}/kinds/model/history`, params);
}

/** pk页 - 规格配备 */
export async function fetchPkCompared(params: any) {
    return await get(`${newCarApiV5}/kinds/pk/equip-spec`, params);
}

/** 推荐车型 */
export async function fetchRecommendKinds(params: any) {
    return await get(`${newCarApiV4}/recommend/compare/models`, params);
}

/** pk页 - 获取数据 */
export async function fetchPkData(params: any) {
    return await get(`${newCarApiV5}/kinds/pk-comprehensive-pc`, params);
}

/** pk页 - 综合 - 推薦比較 */
export async function fetchPkRecommendCompare(params: any) {
    return await get(`${newCarApiV4}/recommend/compare/model-group`, params);
}